// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__8T4lI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3qib_"};